import { render } from "./Point.vue?vue&type=template&id=1eb3b3f0&scoped=true"
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"

import "./Point.vue?vue&type=style&index=0&id=1eb3b3f0&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\wkt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb3b3f0"]])

export default __exports__